import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation, useNavigate } from 'react-router-dom';
import IRouter from '../../interfaces/IRouter';
import './sidebar.css';

interface ISideBar {
    menuData: IRouter[];
    panelName: string;
    baseUrl: string;
    open: boolean;
}

export default function SideBar({ menuData, panelName, baseUrl, open }: ISideBar) {
    const navigate = useNavigate();
    const location = useLocation();

    const showAllowedMenu = menuData.filter((routes) => routes.navbarShow === true);
    const activePath = location.pathname.split('/')[2];

    return (
        <aside className={'xrg-sidebar' + (open ? ' xrg-sidebar-open' : '')}>
            <div
                className="xrg-sidebar-brand cursor-pointer"
                onClick={() => navigate(baseUrl + '/dashboard')}
            >
                <span className="xrg-sidebar-brand-logo">A</span>
                <span className="xrg-sidebar-brand-text">ADICOM</span>
            </div>

            <nav className="xrg-sidebar-nav">
                {showAllowedMenu.map((data, index) => (
                    <div
                        key={index}
                        className={'xrg-nav-link' + (data.path === activePath ? ' xrg-nav-selected' : '')}
                        onClick={() => navigate(baseUrl + '/' + data.path)}
                        title={data.name}
                    >
                        <span className="xrg-nav-icon">
                            <FontAwesomeIcon icon={data.icon} />
                        </span>
                        <span className="xrg-nav-label">{data.name}</span>
                    </div>
                ))}
            </nav>
        </aside>
    );
}
